import { useState } from "react";
import "./style.css";
import { useEffect } from "react";

const colors = {
  c1:"#58F5FF",
  c2:"white"
}

function Bars(options) {

  const [color,set_color]= useState(colors.c2);
  function monitor_color_selection()
  {
     if(options.color ==="c1")
  {
    set_color(colors.c1);
  }else{
    
  set_color(colors.c2);
  }
  }
 useEffect(()=>{
  monitor_color_selection();

 });
 
  return (
    <div className="styled_bars_container" data-aos={options.aos} style={{"width":options.width}}>
    <div className="bar1" style={{"background":color,"height":options.height}}></div>
    <div className="bar2" style={{"background":color,"height":options.height}}></div>
    <div className="bar3" style={{"background":color,"height":options.height}}></div>
   </div>
  )
}
Bars.defaultProps={
  width:"30%",
  height:"0.3rem",
  color:"c1",
  aos:"nothing"

}

export default Bars;